
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';



// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAZXxCxi5Aw6xdfv9n2GkCpY3EjooBy7PU",
  authDomain: "dentai-f319b.firebaseapp.com",
  projectId: "dentai-f319b",
  storageBucket: "dentai-f319b.appspot.com",
  messagingSenderId: "419839093561",
  appId: "1:419839093561:web:8dc4d4d56dfec3770a16e8",
  measurementId: "G-507HWL7R9M"
};

// Inizializza Firebase solo se non è già stato inizializzato
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Esporta le istanze di auth e db
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };